import { mapState, mapGetters, mapActions } from 'vuex'

// Map State
// auth
export const authComputed = {
	...mapState('auth', {
		currentClient: state => state.currentClient,
		currentUser: state => state.currentUser,
		authError: state => state.authError,
	}),
	...mapGetters('auth', ['loggedIn', "isAdmin"]),
}

// config
export const configComputed = {
	...mapState('config', {
		locale: state => state.locale,
		reasons: state => state.reasons,
		clients: state => state.clients,
		deliveryColumns: state => state.deliveryColumns,
		locations: state => state.locations,
		locales: state => state.locales,
	}),
}

// layout
export const layoutComputed = {
	...mapState('layout', {
		layoutType: (state) => state.layoutType,
		leftSidebarTheme: (state) => state.leftSidebarTheme,
		leftSidebarType: (state) => state.leftSidebarType,
		layoutWidth: (state) => state.layoutWidth,
	}),
}

// deliveries
export const deliveriesComputed = {
	...mapState('deliveries', {
		list: state => state.list,
		currentId: state => state.currentId,
		loading: state => state.loading,
		error: state => state.error,
	}),
}

// placeOrder
export const placeOrderComputed = {
	...mapState('placeOrder', {
		uiState: state => state.uiState,
		loading: state => state.loading,
		error: state => state.error,
		templateUrl: state => state.templateUrl,
		file: state => state.file,
		fileUrl: state => state.fileUrl,
		spreadsheetData: state => state.spreadsheetData,
		spreadsheetInfo: state => state.spreadsheetInfo,
		spreadsheetError: state => state.spreadsheetError,

		formats: state => state.formats,
		formatId: state => state.formatId,
		deliveryStage: state => state.deliveryStage,
		deliveryStages: state => state.deliveryStages,

		clientId: state => state.clientId,
		locationId: state => state.locationId,
	}),
}

// spreadsheetSubmissions
export const spreadsheetSubmissionsComputed = {
	...mapState('spreadsheetSubmissions', {
		list: state => state.list,
		loading: state => state.loading,
		error: state => state.error,
	}),
}

// orders
export const ordersComputed = {
	...mapState('orders', {
		list: state => state.list,
		loading: state => state.loading,
		error: state => state.error,
	}),
}

// reports
export const reportsComputed = {
	...mapState("reports", {
		reportTypes: state => state.reportTypes,
		result: state => state.result,
		total: state => state.total,
		lastPage: state => state.lastPage,
		filter: state => state.filter
	})
}

// Map Actions
// auth
export const authMethods = mapActions('auth', ['requestLoginLink', 'verifyLoginLink', 'logOut'])

// layout
export const layoutMethods = mapActions('layout', [
	'changeLayoutType',
	'changeLeftSidebarTheme',
	'changeLeftSidebarType',
	'changeLayoutWidth'
])

// deliveries
export const deliveriesMethods = mapActions('deliveries', ['fetchDeliveries', 'clearDeliveries'])

// placeOrder
export const placeOrderMethods = mapActions('placeOrder', ['uploadSpreadsheet', 'reset', 'clear', 'fetchAllFormats', 'changeFormat', 'changeDeliveryStage', 'changeClient', 'changeLocation'])

// spreadsheetSubmissions
export const spreadsheetSubmissionsMethods = mapActions('spreadsheetSubmissions', ['fetchSpreadsheetSubmissions', 'resetSpreadsheetSubmissions'])

export const ordersMethods = mapActions('orders', ['fetchOrders', 'updateOrder', 'resetOrders'])

//config
export const configMethods = mapActions('config', ['changeLocale', 'fetchReasons', 'fetchClients', 'fetchLocations', 'fetchLocales'])

// reports
export const reportsMethods = mapActions("reports", ['generateReport', 'getReports', "updateFilter", "resetFilter"])

// Helpers
// Get state from storage.
export function getSavedState(key) {
	return JSON.parse(window.localStorage.getItem(key))
}
// Save state to storage
export function saveState(key, state) {
	window.localStorage.setItem(key, JSON.stringify(state))
}
